import HeiClientSideGrid from "../../../../Common/components/HeiClientSideGrid/HeiClientSideGrid";
import * as React from "react";
import { ProjectCostResponse } from "../../../ProjectsList/api/models/ProjectToolCost";
import { getProjectCostColumns, getTemporaryLicenseCostColumns } from "./getProjectCostColumns";
import { costValueFormat } from "../../../../Common/utils/costValueFormat";

interface ProjectCostGridProps {
  projectCostResponse: ProjectCostResponse;
  isLoading: boolean;
  isAdmin?: boolean;
}

const ProjectCostGrid = ({
  projectCostResponse,
  isLoading,
  isAdmin = false,
}: ProjectCostGridProps) => {
  const columns = getProjectCostColumns(projectCostResponse.licenseModes);
  const tempColumns = getTemporaryLicenseCostColumns();
  const hasTempCosts = projectCostResponse.temporaryLicenseCosts?.length > 0;
  const hasStandardCosts = projectCostResponse.standardCosts?.length > 0;

  const costAggregationFooter = () => {
    return (
      <div style={{ paddingRight: "16px", textAlign: "right" }}>
        <strong>
          Total cost per month:{" "}
          {costValueFormat(projectCostResponse.totalCostEstimate)}
        </strong>
      </div>
    );
  };

  const tempCostAggregationFooter = () => {
    return (
      <div style={{ paddingRight: "16px", textAlign: "right" }}>
        <strong>
          Total temporary license cost:{" "}
          {costValueFormat(projectCostResponse.totalTemporaryLicenseCost)}
        </strong>
      </div>
    );
  };

  const standardCostAggregationFooter = () => {
    return (
      <div style={{ paddingRight: "16px", textAlign: "right" }}>
        <strong>
          Total standard cost per month:{" "}
          {costValueFormat(projectCostResponse.totalStandardCost)}
        </strong>
      </div>
    );
  };

  return (
    <>
      <HeiClientSideGrid
        columns={columns}
        rows={projectCostResponse.toolCosts}
        isLoading={isLoading}
        customFooter={costAggregationFooter}
      />
      {isAdmin && hasStandardCosts && (
        <>
          <h3 style={{ marginTop: "24px" }}>Standard License Costs</h3>
          <HeiClientSideGrid
            columns={columns}
            rows={projectCostResponse.standardCosts}
            isLoading={isLoading}
            customFooter={standardCostAggregationFooter}
          />
        </>
      )}
      {isAdmin && hasTempCosts && (
        <>
          <h3 style={{ marginTop: "24px" }}>Temporary License Costs</h3>
          <HeiClientSideGrid
            columns={tempColumns}
            rows={projectCostResponse.temporaryLicenseCosts.map((item, index) => ({ ...item, id: index }))}
            isLoading={isLoading}
            customFooter={tempCostAggregationFooter}
          />
        </>
      )}
    </>
  );
};

export default ProjectCostGrid;
